import styled from 'theme';

export const SectionText = styled.div`
  font-family: ${props => props.theme.variables.typography.secondaryFont};
  font-size: ${props => props.theme.variables.fonts.size.base};
  text-align: center;
`;
